// extracted by mini-css-extract-plugin
export default {"Bar":"Footer_Bar__ogk7J","Action":"Footer_Action__YgRyW","Right":"Footer_Right__35APL","Menu":"Footer_Menu__QMSk9"};